<template lang="pug">
li(
	:key="buzon.Name"
	@click="acceder($event, buzon)"
)
	.info(
		:class="getClase()"
		@mouseenter="entraRaton($event)"
		@mouseleave="saleRaton($event)"
	)
		.icono(@click="desplegar($event)")
			span(:class="buzon.Icono", v-if="buzon.Buzones.length === 0")
			span(v-else)
				span.fa.fa-caret-down(v-if="desplegado")
				span.fa.fa-caret-right(v-else)
		.nombre
			span {{ buzon.Nombre }}
		.contadorMensajes
			span.badge.badge-primary {{ buzon.Mensajes }}
	ul.listadoBuzones(v-if="buzon.Buzones.length > 0 && desplegado")
		Buzon(
			v-for="buz in buzon.Buzones"
			:key="buz.Path"
			:buzon="buz"
			@selected="acceder(null, $event)"
		)
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
export default {
	name: 'Buzon',
	props: ['buzon'],
	data () {
		return {
			desplegado: false,
			hover: false
		}
	},
	computed: {
		...mapGetters({
			buzonActivo: 'webmail/buzonActivo'
		})
	},
	methods: {
		...mapMutations({
			setBuzonActivo: 'webmail/SELECCIONA_BUZON'
		}),
		...mapActions({
			getMensajes: 'webmail/getMensajes'
		}),
		getClase () {
			const clase = []
			if (this.hover) {
				clase.push('resaltar')
			}

			if (this.buzonActivo && this.buzonActivo.Path === this.buzon.Path) {
				clase.push('active')
			}

			return clase.join(' ')
		},
		entraRaton (ev) {
			ev.stopPropagation()
			ev.preventDefault()
			this.hover = true
			// this.setBuzonOver(this.buzon.Path)
		},
		saleRaton (ev) {
			ev.stopPropagation()
			ev.preventDefault()
			this.hover = false
		},
		desplegar (ev) {
			ev.preventDefault()
			ev.stopPropagation()
			this.desplegado = !this.desplegado
		},
		acceder (ev, buzon) {
			if (ev !== null) {
				ev.preventDefault()
				ev.stopPropagation()
			}
			this.$router.push('/main/webmail/' + buzon.Path)
			this.setBuzonActivo(buzon)
			this.getMensajes()
		}
	}
}
</script>

<style scoped>
ul.listadoBuzones {
	list-style-type: none;
	margin: 0;
	padding: 0;
	font-size: 1em;
}

li {
	display: flex;
	flex-direction: column;
	width: 100%;
	margin: 0;
	padding: 0px;
	cursor: pointer;
	transition: opacity 300ms ease-out;
	padding-left: 10px;
}

li > .info.resaltar {
	background-color: rgba(0,0,0,0.2);
}

li > .info {
	display: flex;
	flex-direction: row;
	width: 100%;
	margin: 0;
	padding: 00px;
	cursor: pointer;
	opacity: 0.5;
	transition: opacity 300ms ease-out;
	border-radius: 0 15px 15px 0;
	padding-top: 7px;
	padding-bottom: 7px;
}

li > .info.active {
	opacity: 1;
}

li > .info.active > .nombre {
	font-weight: bold;
}

li > .info > .icono {
	flex-grow: 0;
	flex-shrink: 0;
	flex-basis: 30px;
	max-width: 30px;
	text-align: center;
}

li > .info > .nombre {
	flex-grow: 1;
	flex-shrink: 1;
	text-align: left;
}

li > .info > .contadorMensajes {
	flex-grow: 0;
	flex-shrink: 0;
	flex-basis: 30px;
	max-width: 30px;
	text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/modulos/webmail/vue/components/buzones/buzon.vue